import React, { useContext, useState, useEffect } from "react"
import Loader from "../ui/loader"
import useLoading from "../../hooks/useLoading"
import { Button } from "../ui/button"
import { ContactRequests } from "../../api/app.service"
import { SvgClose } from "../icons"
import { UserCtx } from "../../context/userContext"
import { useToast } from "../../hooks/useToast"

interface Props {
  setShowConfirmInviteModal: any
  invites: any
  setInvites: any
  contacts: any
}
const CoachDirectoryInvite: React.FC<Props> = ({
  setShowConfirmInviteModal,
  invites,
  setInvites,
  contacts,
}) => {
  const [validInvites, setValidInvites] = useState<any>([])
  const [isSubmit, setIsSubmit] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const { user } = useContext(UserCtx)
  const { startLoading, stopLoading } = useLoading()
  const { toast } = useToast()
  const [submitObject, setSubmitObject] = useState<any>({
    invites: [],
    subject: "Connect with me on Zoee!",
    description: `Please log in to the Zoee coaching portal. It serves as a hub and central location for the coaching work we will do together.`,
  })
  const getMemberName = () => {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`
    } else {
      return user?.email
    }
  }
  const [customMessage, setCustomMessage] = useState<string>("")
  const generalMessage =
    user?.activeProfile === "coach"
      ? `Hi, I'm a Coach ${user?.firstName} ${user?.lastName}. Let's connect on Zoee Client Portal`
      : `Hi, my name is ${getMemberName()}. Let's connect on Zoee Client Portal`

  const submitInvitesForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsSubmit(true)
    let emailArray: any[] = []
    validInvites.forEach((invite: any) => emailArray.push(invite.email))
    setSubmitObject({ ...submitObject, invites: emailArray })
  }

  const closeAndReset = () => {
    setValidInvites([])
    setInvites([{ name: "", email: "" }])
    setShowConfirmInviteModal(false)
  }

  const removeInvite = (invite: any) => {
    const inviteCount = validInvites.length
    if (inviteCount <= 1) {
      closeAndReset()
    } else {
      const filtered = validInvites.filter((item: any) => {
        return invite.email !== item.email
      })
      setValidInvites(filtered)
      setInvites(filtered)
    }
  }

  const sendInvites = () => {
    if (user?.coachProfile || user?.memberProfile) {
      setLoading(true)
      startLoading()
      const existingContacts = contacts
        .filter((contact: any) => contact.contact_type !== "prospect")
        .map((contact: any) => contact.email?.toLocaleLowerCase())
      const inviteEmails = validInvites.map((invite: any) =>
        invite.email?.toLocaleLowerCase()
      )
      if (
        inviteEmails.some((email: string) => existingContacts.includes(email))
      ) {
        toast.error("The email you entered is already in your contacts.")
        setLoading(false)
        stopLoading()
        setIsSubmit(false)
      } else {
        ContactRequests.createContactRequest({
          profile_id: user.activeProfileId,
          contact_requests: inviteEmails,
          description: submitObject.description,
          subject: submitObject.subject,
          custom_message: customMessage || generalMessage,
          avatar_url: user?.avatar_url,
          sender_email: user?.email,
          has_avatar: user?.hasAvatar,
        })
          .then(() => {
            setLoading(false)
            closeAndReset()
            toast.success("Invites sent successfully!")
            localStorage.setItem("showCoachDirectory", "true")
            window.location.reload()
          })
          .catch((ex) => {
            console.error(ex)
            if (ex.response?.data?.error_detail) {
              toast.error(ex.response.data.error_detail)
            } else {
              toast.error(ex.response?.data?.message || "An error occurred.")
            }
            setLoading(false)
            stopLoading()
          })
      }
    }
    setIsSubmit(false)
  }

  useEffect(() => {
    if (isSubmit) {
      sendInvites()
    }
  }, [isSubmit, submitObject])

  useEffect(() => {
    const filledInvites = invites.filter((invite: { email: string }) => {
      const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/
      return invite.email && invite.email.match(mailformat)
    })
    setValidInvites(filledInvites)
  }, [])

  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen pb-[120px] zoee-backdrop-filter z-[801] flex items-center justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      <form
        action="#"
        onSubmit={(e) => {
          e.preventDefault()
          e.stopPropagation()
          submitInvitesForm(e)
        }}
      >
        {" "}
        <div
          className="py-[16px] sm:py-[32px] px-[24px] sm:px-[48px] w-[351px] sm:w-auto bg-white 
                    main-shadow rounded-[16px] flex flex-col items-center relative mt-[50px] md:mt-[100px]"
        >
          <SvgClose
            className="absolute top-[24px] right-[24px] cursor-pointer"
            onClick={closeAndReset}
          />
          {validInvites.map((invite: any, index: any) => (
            <h2
              key={index}
              className="text-[18px] md:text-[22px] font-bold mb-[24px] text-center"
            >
              Connect with
              <br />
              <span className="text-[16px] md:text-[18px] font-bold text-gray-600 break-all">
                {invite.name || invite.email}
              </span>
            </h2>
          ))}
          <div className="w-full flex items-center justify-center mt-[16px]">
            {loading ? (
              <Loader />
            ) : (
              <Button type="submit">
                {`Add Coach${validInvites.length > 1 ? "s" : ""}`}
              </Button>
            )}
          </div>
        </div>
      </form>
    </div>
  )
}
export default CoachDirectoryInvite
